export const REQUEST_HEADER = {
  //Accept: 'application/json',
  //'Content-Type': 'application/json',
  //'X-Requested-With': 'XMLHttpRequest',
  'Content-Type': 'application/json',
  //'Content-Type': 'text/plain'
}
